import type { FC } from "react";

interface SummaryHeaderProps {
  title: string;
  onMoreClick?: () => void;
}

export const SummaryHeader: FC<SummaryHeaderProps> = ({
  title,
 /*  onMoreClick, */
}) => {
  return (
    <div className="w-full pt-10 px-3">
      <div className="flex items-end w-full justify-between text-lg text-white uppercase tracking-[.25em] [text-shadow:0_2px_30px_rgba(0,0,0,.3)] pb-2 mb-6 border-b border-white">
        {title}
        {/* <div className="text-xs mb-1 cursor-pointer" onClick={onMoreClick}>
          More
        </div> */}
      </div>
    </div>
  );
};
